// extracted by mini-css-extract-plugin
module.exports = {"sectionPromo":"SectionPromo_sectionPromo__QOIk_","heading":"SectionPromo_heading__kybCp","container":"SectionPromo_container__Ty7C2","subheading":"SectionPromo_subheading__i4w8m"};